import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-tabset';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PdfComponent } from './pdf/pdf.component';
@NgModule({
  declarations: [
    PdfComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TabsModule,
    ReactiveFormsModule,
    NgxScrollTopModule,
    NgxExtendedPdfViewerModule
  ],exports:[ PdfComponent]
})
export class CommonComponentModule { }
